module.exports = __webpack_public_path__ + "img/crest_2x.png";